import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ConsultsList from 'features/consults/components/ConsultsList/ConsultsList';
import ConsultDetailsWrapper from 'features/consults/components/ConsultDetailsWrapper/ConsultDetailsWrapper';
import { ServiceTypeEnum } from 'utils/enums';

const PedsEegConsults = () => (
  <Routes>
    <Route
      path="/"
      element={<ConsultsList consultType={ServiceTypeEnum.PEDS_EEG} />}
    />
    <Route
      path="/:consultId"
      element={<ConsultDetailsWrapper consultType={ServiceTypeEnum.PEDS_EEG} />}
    />
  </Routes>
);

export default PedsEegConsults;
